<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_company.add_company')">
    <template #content>
      <v-container class="add-company">
        <v-form v-model="isFormValid"
                ref="addCompanyForm">
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('admin_company.name_en')"
                            v-model="company.name_en"
                            clearable
                            :rules="requiredRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('admin_company.name_zh')"
                            v-model="company.name_zh"
                            clearable
                            :rules="requiredRules"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.addCompanyForm.validate() && save()">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {ref, watch} from "@vue/composition-api";

export default {
  name: 'AddCompanyModal',
  components: {BGModal},
  props: {
    shown: Boolean,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          company.value = {};
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    // Form
    const isFormValid = ref(false);

    const company = ref({});

    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const save = function () {
      root.$callAPI('hkiarace/admin/company/create/', {
        ...company.value,
      }, () => {
        emit('finish');
      });
    }

    return {
      dialogShown,
      cancel,

      isFormValid,
      company,

      requiredRules,

      save,
    }
  }
}
</script>
